/**
 * Determines if the value is a promise-like object.
 *
 * @param value
 */
export function isPromiseLike<T = unknown>(
  value: unknown,
): value is PromiseLike<T> {
  return (
    value !== null &&
    typeof value === 'object' &&
    'then' in value &&
    typeof value.then === 'function'
  )
}

/**
 * Implementation of standard `Promise.withResolvers` which is newly available, but just in case some
 * old geezers are still running Netscape Navigator we'll use a custom implementation for now.
 */
export function withResolvers<T>() {
  let resolve!: (value: T | PromiseLike<T>) => void
  let reject!: (reason?: unknown) => void
  const promise = new Promise<T>((res, rej) => {
    resolve = res
    reject = rej
  })
  return { promise, resolve, reject }
}
